import React, { useContext, useCallback } from 'react';
import { Listing } from '../../../../../models/Listing';
import api from '../../../../../api';
import { processLCWValuesBeforeSubmit } from '../../utils';
import PatchListingContexts from './PatchListing.context';
import { DeepPartial } from 'types';
import StepsContext from 'providers/Steps/Steps.context';
import ListingContext from '../Listing/Listing.context';

export type PatchListingProviderProps = {
  children?: React.ReactNode;
};

const PatchListingProvider: React.FC<PatchListingProviderProps> = (props) => {
  const { children } = props;

  const { listing, setListing } = useContext(ListingContext);
  const { currentStep } = useContext(StepsContext);

  const patchListingValue = useCallback(
    async (values: DeepPartial<Listing>, updatedValues?: Partial<Listing>) => {
      if (!listing) return;

      const processedValues = processLCWValuesBeforeSubmit(values);

      try {
        await api.listings.patchListing(listing._id, {
          ...processedValues,
          currentStep,
        });

        setListing((old) => ({
          ...old,
          ...updatedValues,
        }));
      } catch {
        return;
      }
    },
    [currentStep, listing, setListing],
  );

  return (
    <PatchListingContexts.Provider
      value={{
        patchListingValue,
      }}
    >
      {children}
    </PatchListingContexts.Provider>
  );
};

export default PatchListingProvider;
